import { NewCustomFunctionDefinition, CustomFunctionDefinitionPartial } from '@rappider/rappider-sdk';

export function removeEmptyFields(body: NewCustomFunctionDefinition | CustomFunctionDefinitionPartial): NewCustomFunctionDefinition | CustomFunctionDefinitionPartial {
  return Object.entries(body)
    .filter(([_, v]) => !!v)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
